import { Search } from '@shared/components/ui/Search';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void; // Ejecuta búsqueda (Enter)
}

// Barra de búsqueda de presets
export const SearchBar = ({ value, onChange }: SearchBarProps) => {
  const { t } = useTranslation('shippingRulePresetsModule');
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue((prev) => (prev === value ? prev : value));
  }, [value]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="flex-1 max-w-xs">
      <Search
        value={inputValue}
        onChange={handleInputChange}
        onEnter={(searchValue) => onChange((searchValue ?? '').trim())}
        placeholder={t('search.placeholder')}
        dataTestId="presets-search"
        inputDataTestId="presets-search-input"
      />
    </div>
  );
};
